import {IPage, IVersionedId, ServiceBase} from '@/services/ServiceBase';
import * as request from 'superagent';

const API_URL = `${process.env.VUE_APP_API_URL}/worksheets`;

export class WorksheetsService extends ServiceBase {
    public static async getWorksheets(page: number, perPage: number): Promise<IPage<IWorksheet>> {
        try {
            const result = await (this.authRequest(request
                .get(API_URL)))
                .query(`page=${page}`)
                .query(`perPage=${perPage}`)
                .timeout(10000);
            return result.body;
        } catch (err) {
            console.error('Error while fetching worksheets!', err);
            throw err;
        }
    }

    public static async getWorksheet(id: number): Promise<IUpdatableWorksheet> {
        try {
            const result = await (this.authRequest(request
                .get(`${API_URL}/${id}`)
                .timeout(10000)));

            return result.body;
        } catch (err) {
            console.error(`Error while fetching a single worksheet with id ${id}`, err);
            throw err;
        }
    }

    public static async createWorksheet(req: ICreateWorksheetRequest): Promise<IVersionedId> {
        try {
            const result = await (this.authRequest(request
                .post(API_URL)))
                .send(req)
                .timeout(5000);

            return result.body;
        } catch (err) {
            console.error('Error while creating worksheet!', err);
            throw err;
        }
    }

    public static async updateWorksheet(req: IUpdatableWorksheet): Promise<IVersionedId> {
        try {
            const result = await (this.authRequest(request
                .patch(`${API_URL}/${req.id}`)
                .send(req)
                .timeout(5000)));

            return result.body;
        } catch (err) {
            console.error('Error while updating worksheet!', err);
            throw err;
        }
    }

    public static async deleteWorksheet(id: number): Promise<void> {
        try {
            await (this.authRequest(request
                .delete(`${API_URL}/${id}`)))
                .timeout(5000);
        } catch (err) {
            console.error('Error while deleting worksheet!', err);
            throw err;
        }
    }

    public static async downloadPdf(id: number): Promise<any> {
        try {
            const result = await (this.authRequest(request
                .get(`${API_URL}/${id}/pdf`)))
                .responseType('blob')
                .timeout(5000);

            return result.body;
        } catch (err) {
            console.error('Error while downloading pdf!', err);
            throw err;
        }
    }
}

export interface IWorklog {
    sort_order?: number;
    date?: string;
    description?: string;
    hours?: string;
}

export interface IMaterial {
    sort_order?: number;
    description?: string;
    emId?: string;
    quantity?: string;
}

export interface IWorksheet {
    userId: number;
    dnId: string;
    smId: string;
    wsId: string;
    sheetDate: string;
    locationName: string;
    locationAddress: string;
    customerOfficialName?: string;
    customerName?: string;
    customerSignatureImage: string;
    distanceRelation?: string;
    distanceKm?: string;
    worklogs: IWorklog[];
    materials: IMaterial[];
}

export interface IUpdatableWorksheet extends IWorksheet {
    id: number;
    version: number;
    worklogs: ICreateWorklogRequest[];
    materials: ICreateMaterialRequest[];
}

export interface ICreateWorklogRequest {
    sort_order?: number;
    date?: string;
    description?: string;
    hours?: string;
}

export interface ICreateMaterialRequest {
    sort_order?: number;
    description?: string;
    emId?: string;
    quantity?: string;
}

export interface ICreateWorksheetRequest {
    dnId: string;
    smId: string;
    wsId: string;
    sheetDate: string;
    locationName: string;
    locationAddress: string;
    customerOfficialName?: string;
    customerName?: string;
    customerSignatureImage: string;
    distanceRelation?: string;
    distanceKm?: string;
    worklogs: ICreateWorklogRequest[];
    materials: ICreateMaterialRequest[];
}
